
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTVSession } from './tvSession';

export default function withAuth(Component) {
  return function AuthenticatedComponent(props) {
    const navigate = useNavigate();
    const [session, setSession] = useState(getTVSession);

    useEffect(() => {
      const refresh = () => setSession(getTVSession());
      window.addEventListener('storage', refresh);
      return () => window.removeEventListener('storage', refresh);
    }, []);

    useEffect(() => {
      if (!session) {
        localStorage.removeItem('centerdata');
        localStorage.removeItem('tldata');
        navigate('/'); 
      }
    }, [navigate, session]);

    return session ? <Component key={`${session.login_type}-${session.centerid || session.center_id}-${session.center_mis_id || 0}`} {...props} tvSession={session} /> : null;
  };
}
